export default {
  config: {
    productName: 'Lucky Six',
  },
  payinDisabled: true,
  requestDisabled: false,
  timeToRemoveNotification: 3000,
  ticketsHistory: [],
  expandTicketHistory: true,
};
